export const LOADING_START = 'views/common/LOADING_START'
export const LOADING_END = 'views/common/LOADING_END'
export const SET_NOTIFICATION = 'views/common/SET_NOTIFICATION'
